const initialBoggleState={
    isFetching: false,
    hasError: false,
    boggleBoard:[],
    validWords:[],
    hasGameEnded: false,
    totalTimeInSec: 180,
    error: '',
    correctWords:[],
    incorrectWords:[],
    score:0
}

export default initialBoggleState;